import { Link } from "react-router-dom";
import ColumnContainer from "../../../common/ColumnContainer";
import { AddProjectComponent } from "./style";
import { userDashboardRoute } from "../../../../utils/routes/Routes";
import RowContainer from "../../../common/RowContainer";
import { Add } from "@mui/icons-material";
import { Divider, Typography } from "@mui/material";
import { FormattedMessage } from "react-intl";
import { DashboardButton } from "../../../common/DashboardButton";

export default function AddNewProject() {
  return (
    <AddProjectComponent>
      <ColumnContainer halfGap style={{ width: "100%" }}>
        <Typography variant="h6" component="h6">
          <FormattedMessage id="dashboard.review.addProjectTitle" />
        </Typography>
        <Divider />
        <Typography variant="p" component="p">
          <FormattedMessage id="dashboard.review.addProjectSubtitle" />
        </Typography>

        <Link to={userDashboardRoute.newProject}>
          <DashboardButton type="filled">
            <RowContainer align="center" center minGap>
              <Add />
              <FormattedMessage id="button.newProject" />
            </RowContainer>
          </DashboardButton>
        </Link>
      </ColumnContainer>
    </AddProjectComponent>
  );
}
